export const config_prod = 
    {
        apiEndpoint: {
            base_url:"https://dga-backend.onrender.com/",
            format:"url",
            default:"https://dga-backend.onrender.com/",
            env:"API_ENDPOINT"
        }
    }

